export default function LocalNetworkSection() {
  const networkStats = [
    {
      number: '40+',
      label: '협력 공방',
      icon: 'ri-store-2-line',
    },
    {
      number: '15',
      label: '지역 거점',
      icon: 'ri-map-pin-line',
    },
    {
      number: '120+',
      label: '네트워크 인력',
      icon: 'ri-team-line',
    },
  ];

  const benefits = [
    {
      icon: 'ri-exchange-line',
      title: '기술 교류',
      description: '각 공방의 전문 기술과 노하우를 공유하며 함께 성장합니다.',
    },
    {
      icon: 'ri-shopping-bag-line',
      title: '공동 생산',
      description: '대량 주문이나 특수 제작 시 네트워크를 통해 협력 생산합니다.',
    },
    {
      icon: 'ri-lightbulb-line',
      title: '교육 협력',
      description: '기술 교육 프로그램을 함께 운영하며 신규 인력을 양성합니다.',
    },
    {
      icon: 'ri-hand-heart-line',
      title: '상생 협력',
      description: '공정한 거래와 상호 존중을 바탕으로 지속가능한 관계를 만듭니다.',
    },
  ];

  return (
    <section className="py-32 px-6 bg-gradient-to-b from-stone-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-stone-800 mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            지역 네트워크
          </h2>
          <p className="text-xl text-stone-600 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
            지역 봉제 공방 협력
          </p>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mt-8"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {networkStats.map((stat, index) => (
            <div
              key={index}
              className="bg-white p-10 rounded-2xl shadow-lg text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${stat.icon} text-4xl text-emerald-700`}></i>
              </div>
              <div className="text-5xl font-bold text-emerald-700 mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                {stat.number}
              </div>
              <p className="text-xl text-stone-700 font-medium" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        <div className="mb-20">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/6191af1bfcc380795e8bf63cdb9fa212.jpg"
              alt="지역 네트워크"
              className="w-full h-[500px] object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-12 text-white">
              <p className="text-3xl font-bold leading-relaxed mb-4" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
                함께 만드는 지속가능한 생태계
              </p>
              <p className="text-lg leading-relaxed max-w-3xl">
                Daygreen은 단독으로 성장하지 않습니다. 지역의 봉제 공방들과 네트워크를 형성하여 
                함께 성장하고, 서로를 지원하며, 지속가능한 산업 생태계를 만들어갑니다.
              </p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl border border-stone-200 hover:border-emerald-600 transition-all duration-300 hover:shadow-lg"
            >
              <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-2xl text-emerald-700`}></i>
              </div>
              <h3 className="text-xl font-bold text-stone-800 mb-3" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
                {benefit.title}
              </h3>
              <p className="text-stone-600 leading-relaxed text-sm">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-emerald-600 rounded-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-6" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
            네트워크에 참여하고 싶으신가요?
          </h3>
          <p className="text-lg leading-relaxed mb-8 max-w-2xl mx-auto">
            봉제 기술을 가지고 계시거나, 공방을 운영하고 계신다면 
            Daygreen 네트워크에 함께하실 수 있습니다.
          </p>
          <button className="bg-white text-emerald-700 px-10 py-4 rounded-full font-semibold text-lg hover:bg-stone-50 transition-colors duration-300 whitespace-nowrap cursor-pointer">
            참여 문의하기
          </button>
        </div>
      </div>
    </section>
  );
}